module.exports = __webpack_public_path__ + "img/greenPlusIcon.3a1515cc.svg";